<template>
    <div>
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="$refs.edit.showDialog()">添加</el-button>
        </div>
        <div class="table-wrap">
            <el-table v-loading="loading" :data="tableData" style="width: 500px">
                <el-table-column prop="user_id" label="绑定的用户id"></el-table-column>
                <el-table-column prop="user_name" label="用户名"></el-table-column>
                <el-table-column prop="name" label="操作" width="80">
                    <template slot-scope="scope">
                        <div class="table-btn-column">
                            <el-button type="text" size="small" @click="$refs.edit.showDialog(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="deleteClick(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <!--编辑-->
        <Edit ref="edit" @closeDialog="getTableList"></Edit>
    </div>
</template>

<script>
    import SettingApi from "@/api/setting.js";
    import Edit from './Edit.vue'
    export default {
        components: {
            Edit,
        },
        data() {
            return {
                /*是否在提交*/
                loading: false,
                /*表单数据*/
                tableData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
            };
        },
        created() {
            this.getTableList();
        },
        methods: {
            getTableList() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                SettingApi.wxMsgUser.list(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list;
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*删除*/
            deleteClick (row) {
                let self = this
                self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText : '取消',
                    type             : 'warning'
                }).then(() => {
                    SettingApi.wxMsgUser.delete({ merch_user_id: row.merch_user_id }, true)
                        .then((res) => {
                            if (res.code == 1) {
                                self.$message.success(res.msg)
                                self.getTableList()
                            } else {
                                self.$message.error('错了哦，这是一条错误消息')
                            }
                        }).catch((error) => {})
                })
            },


        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setting/wxmsguser/index.vue